import angular from 'angular';
import { ApplicationsApi } from './services/applications';
import { AwatChecklistApi } from './services/awat-checklist';
import { AwatSettingsApi } from './services/awat-settings';
import { RentalHistoryVerificationSettingsApi } from './services/rental-history-verification-settings';
import { RentalHistoryVerificationRequestsApi } from './services/rental-history-verification-requests';
import { LeasesApi } from './services/leases';
import { RecurringTransactionsApi } from './services/recurring-transactions';
import { BankFeedApi } from './services/bank-feed';
import { SettingsApi } from './services/settings';
import { ManagementIncomeApi } from './services/management-income';
import { ExportsApi } from './services/exports';
import { PaymentsApi } from './services/payments';
import { BillsApi } from './services/bills';
import { InvoicesApi } from './services/invoices';
import { FinancialsApi } from './services/financials';
import { MerchantLimitsApi } from './services/merchant-limits';
import { MailingTemplateApi } from './services/mailing-template';
import { MailingsApi } from './services/mailings';
import { ViolationsApi } from './services/violations';
import { TermsOfUseApi } from './services/terms-of-use';
import { RenewalsApi } from './services/renewals';
import {JournalApiService} from './services/journal';
import {UserRolesApi} from './services/user-roles';
import { FilesApi } from './services/files';
import {BillingApi} from './services/billing';
import {StatesApi} from './services/states';
import {BankingApi} from './services/banking';
import { RentalOwnersApi } from './services/rental-owners';
import { RecurringChargesApi } from './services/recurring-charge-api';
import { LoggingApi } from './services/logging';
import { RentersInsuranceApi } from './services/renters-insurance';
import { ViolationMailingsApi } from './services/violation-mailings';
import { ViolationEmailsApi } from './services/violation-emails';
import { UsersApi } from './services/users';
import { UserSessionApi } from './services/user-session-api';
import { GeneralLedgerApi } from './services/general-ledger';
import { ChargesApi } from './services/charges';
import { CommunicationsApi } from './services/communications';
import { OwnerContributionsApi } from './services/owner-contributions';
import {ApmApi} from './services/apm-api';
import { DepositsApi } from './services/deposits';
import { CheckEftsApi } from './services/check-etfs-api';
import {GlobalSearchApi} from './services/global-search';
import { TenantsApi } from './services/tenants';
import { VendorsApi } from './services/vendors';
import { BillMarkupsApi } from './services/bill-markups';
import { NotesApi} from './services/notes';
import { PropertyContactsApi } from './services/property-contacts';
import { AssociationsApi } from './services/associations';
import { AccountSettingsApi } from './services/account-settings';
import { LeaseCosignersApi } from './services/lease-cosigners';
import { ApplicantsApi } from './services/applicants';
import { LeaseStagesApi } from './services/lease-stages';
import { AnnouncementApi } from './services/announcement';
import { RentApi } from './services/rent';
import { HttpModule } from '@buildium/angularjs-core/dist/http';
import { AccountAndBillingApi } from './services/account-and-billing';
import {PublicFeatureFlagsApi} from './services/public-feature-flags';
import { PermissionsApi } from './services/permissions';
import { AccountApi } from './services/account';
import { AuthenticationApi } from './services/authentication';
import { FeatureFlagsApi } from './services/featureflags';
import { ResidentSiteApi } from './services/resident-site';
import { AccessKeysApi } from './services/access-keys';
import { GroupEmailApi } from './services/group-email';
import { ServiceFlagApi } from './services/serviceflags';
import { PrepaymentsApi } from './services/prepayments';
import {AssociationOwnersApi} from './services/association-owners';
import {ExternalApiManagementApi} from './services/external-api-management';
import {GLAccountsApi} from './services/glaccounts';
import {FreeTrialApi} from './services/freetrial';
import {PublicsiteApi} from './services/public-site';
import {AccountingBooksApi} from './services/accounting-books';
import {S3UploadTicketApi} from './services/s3-upload-ticket';
import {DashboardApi} from './services/dashboard';
import {NavigationApi} from './services/navigation';
import {ShortcutsApi} from './services/shortcuts';
import {DraftLeaseApi} from './services/draft-lease';
import {DraftTenantsApi} from './services/draft-tenants';
import {CategoriesApi} from './services/categories';
import {StaffMemberApi} from './services/staff-member';
import {EventHistorySettingsApi} from './services/event-history-settings';
import {TaskHistoriesApi} from './services/task-histories';
import {LinkedAccountApi} from './services/linked-account';
import {MailingSenderApi} from './services/mailing-sender';
import {LateFeePolicyApi} from './services/late-fee-policies';
import {MailingLayoutApi} from './services/mailing-layout';
import {PhoneApi} from './services/phone';
import {PropertyInspectionApi} from './services/property-inspection';
import {PromoterSurveyApi} from './services/promoter-survey-api';
import {DiscussionMessagesApi} from './services/discussion-messages';
import {PropertyGroupsApi} from './services/property-groups';
import {BackgroundChecksApi} from './services/background-checks';
import {BasicApplicantScreeningApi} from './services/basic-applicant-screening';
import {ReportsApi} from './services/reports';
import {InsightsApi} from './services/insights';
import {AssociationTenantsApi} from './services/association-tenants';
import {AccountingStartDateApi} from './services/accounting-start-date';
import {NewAccountSetupApi} from './services/new-account-setup/new-account-setup';
import {RentRollApi} from './services/rent-roll';
import {EpaySignupApi} from './services/epay-application';
import {EpayBillingApi} from './services/epay-billing';
import {EpaySettingsApi} from './services/epay-settings';
import {ChatApi} from './services/chat';
import {InspectionsApi} from './services/inspections';
import {AddOnServicesSettingsApi} from './services/addonservices-settings';
import {PrioritySupportApi} from './services/priority-support';
import {ESignAuthenticationApi} from './services/esign-authenticate';
import {ESignBillingApi} from './services/esign-billing';
import {ESignMembershipService} from './services/esign-membership';
import {LeaseTemplatesApi} from './services/lease-templates';
import {TestEpayProvisioning} from './services/test-epay-provisioning';
import {Misc1099Api} from './services/misc1099';
import {UserEftAccountApi} from './services/user-eft-account-api';
import {ChecksApi} from './services/checks-api';
import {OwnerPortalApi} from './services/owner-portal';
import { PartnerPortalApi } from './services/partner-portal';
import {SiteMessagesApi} from './services/site-messages';
import {ProductUpdatesApi} from './services/product-updates-api';
import {RetailCashApi} from './services/retail-cash';
import {AutomatedEmailTemplatesApi} from './services/automated-email-templates';
import {ShowingsCoordinatorApi} from './services/showings-coordinator-api';
import {UserProfilePhotoApi} from './services/user-profile-photo-api';
import {OutstandingBalancesApi} from './services/outstanding-balances';
import {EngagementApi} from './services/engagement-engine';
import {ApplicationBrandingApi} from './services/application-branding';
import {BusinessProcessApi} from './services/business-processes';
import {ImportsApi} from './services/imports';
import {ApplianceApi} from './services/appliance-api';
import {PropertyImagesApi} from './services/property-images';
import {SavingsRecommendationApi} from './services/savings-recommendation';
import {ApprovalLimitsApi} from './services/approval-limits';
import {BoardMembersApi} from './services/board-members';
import {UserAgreementsApi} from './services/user-agreements';
import {CustomerBetaApi} from './services/customer-beta';
import {ResourceStringsApi} from './services/resource-strings-api';
import {OwnerDrawApi} from './services/owner-draw';
import {WebSocketsApi} from './services/web-sockets';
import {CountryApi} from './services/country';
import {SetupTwoFactorAuthenticationApi} from './services/set-up-two-factor-authentication';
import {TwoFactorAuthenticationApi} from './services/two-factor-authentication';
import {MarketingPreferencesApi} from './services/marketing-preferences';
import {ApprovalRequestsApi} from './services/approval-requests';
import {OutgoingEftRequestsApi} from './services/outgoing-eft-requests';
import {CommonAllocationsApi} from './services/common-allocations';
import {UnitDetailsApi} from './services/unit-details';
import { ApprovalsApi } from './services/approvals';
import {ResidentInvoicesApi} from './services/resident-invoices';
import {TasksApi} from './services/tasks';
import { ManagerLocalizationModule } from '../localization/localization.module';
import {PropertiesApi} from './services/properties';
import {FeePolicySettingsApi} from './services/fee-policy-settings';
import {ConstantsModule} from '@buildium/angularjs-core/dist/constants';
import {BankAccountOpeningBalancesApi} from './services/new-account-setup/bank-account-opening-balances';
import {AssociationUsersApi} from './services/association-users';
import {EventHistoryApi} from './services/event-history-api';
import {ListingsApi} from './services/listings';
import {MailgunApi} from './services/mailgun';
import {ResidentsApi} from './services/residents';
import {TrialWalkthroughApi} from './services/trial-walkthrough';
import {ContactsApi} from './services/website-contact';
import {BudgetsApi} from './services/budgets';
import {RecurringTasksApi} from './services/recurring-task';
import {ApplicationGroupsApi} from './services/application-groups';
import {ActivityFeedApi} from './services/activity-feed';
import { OpenApiPartnersApi } from './services/open-api-partners';
import { MarketplaceApi } from './services/marketplace';
import {UnreadActivitiesApi} from './services/unread-activities';
import {OwnershipAccountsApiModule} from './services/ownership-accounts/owner-accounts.module';
import {BankVerificationApi} from './services/bank-verification';
import { WebhooksEventHistoryApi } from './services/webhooks-event-history';
import { PremiumApplicantScreeningApi } from './services/premium-applicant-screening';
import { AssociationCommitteesApi } from './services/association-committees';
import { AssociationArchitecturalRequestsApi } from './services/association-architectural-requests';
import { ArchitecturalRequestsApi } from './services/architectural-requests';
import { ArchitecturalRequestApprovalsApi } from './services/architectural-request-approvals';
import { UnauthenticatedAccountSettingsApi } from './services/unauthenticated-account-settings-api';
import { DraftEmailApi } from './services/draft-email-api';
import { ScheduledEmailApi } from './services/scheduled-email-api';
import { MasterInsuranceApi } from './services/master-insurance';
import { SetupIntentsApi } from './services/setup-intents';
import { LockboxProcessingApi } from './services/lockbox-processing';
import { ApplicationFinancialsApi } from './services/application-financials-api';
import { ApplicationPaymentsApi } from './services/application-payments-api';
import { ApplicationChargesApi } from './services/application-charges-api';
import { ApplicationReversedPaymentsApi } from './services/application-reversed-payments-api';
import { PropertySettingsApi } from './services/property-settings-api';
import { ApplicationRefundsApi } from './services/application-refunds-api';
import {ApplicationInvoicesApi} from './services/application-invoices-api';
import {BankFeedRulesApi} from './services/bank-feed-rules';
import { TotalPercentageDistributionApi } from './services/total-percentage-distribution';
import { MerchantApplicationDocumentApi} from './services/merchant-application-documents';
import { KnownOpenApiPartnersApi } from './services/known-open-api-partners';
import { ReturnedPaymentAutomationFeeApi } from './services/returned-payment-automation-fee-api';
import {BinRangesApi} from './services/bin-validation';
import { ReturnedPaymentAutomationBankFeesApi } from './services/returned-payment-automation-bank-fees-api';
import { ReversedEFTRefundsApi } from './services/reversed-eft-refunds-api';
import { CreditCardAccountsApi } from './services/credit-card-accounts-api';
import { ProjectsApi } from './services/projects-api';
import { CreditCardPurchasesApi } from './services/credit-card-purchases-api';
import { CreditCardBalancePaymentsApi } from './services/credit-card-balance-payments-api';
import { VirtualAssistantApi } from './services/virtual-assistant';
import { RentalProspectSharedApi } from './services/rental-prospect-shared-api';
import { ProjectTemplatesApi } from './services/project-templates-api';
import { EmailSettingsApi } from './services/email-settings-api';
import { ProjectTemplateTasksApi } from './services/project-template-tasks-api';
import { ApplicationFeesApi } from './services/application-fees-api';
import { WorkSessionsApi } from './services/work-sessions-api';
import { OcrApi } from './services/ocr';
import { SecurityDepositPartnerApi } from './services/security-deposit-partner';

export const ManagerApiModule = angular.module('buildium.manager.api',
    [
        ConstantsModule.name, // this contains constants that are used in the different services
        ManagerLocalizationModule.name,
        HttpModule.name,
        OwnershipAccountsApiModule.name
    ])
    .service('GLAccountsApi', GLAccountsApi)
    .service('ChargesApi', ChargesApi)
    .service('AccountSettingsApi', AccountSettingsApi)
    .service('FreeTrialApi', FreeTrialApi)
    .service('PublicsiteApi', PublicsiteApi)
    .service('ResidentSiteApi', ResidentSiteApi)
    .service('PermissionsApi', PermissionsApi)
    .service('FeatureFlagApi', FeatureFlagsApi)
    .service('PublicFeatureFlagsApi', PublicFeatureFlagsApi)
    .service('ServiceFlagApi', ServiceFlagApi)
    .service('GlobalSearchApi', GlobalSearchApi)
    .service('S3UploadTicketApi', S3UploadTicketApi)
    .service('DashboardApi', DashboardApi)
    .service('NavigationApi', NavigationApi)
    .service('ShortcutsApi', ShortcutsApi)
    .service('DraftLeaseApi', DraftLeaseApi)
    .service('DraftTenantsApi', DraftTenantsApi)
    .service('LeaseCosignersApi', LeaseCosignersApi)
    .service('CategoriesApi', CategoriesApi)
    .service('StaffMemberApi', StaffMemberApi)
    .service('AuthenticationApi', AuthenticationApi)
    .service('EventHistorySettingsApi', EventHistorySettingsApi)
    .service('TaskHistoriesApi', TaskHistoriesApi)
    .service('AccountApi', AccountApi)
    .service('AccountAndBillingApi', AccountAndBillingApi)
    .service('LinkedAccountApi', LinkedAccountApi)
    .service('RentersInsuranceApi', RentersInsuranceApi)
    .service('MailingSenderApi', MailingSenderApi)
    .service('LateFeePolicyApi', LateFeePolicyApi)
    .service('MailingLayoutApi', MailingLayoutApi)
    .service('GroupEmailApi', GroupEmailApi)
    .service('FilesApi', FilesApi)
    .service('PropertyInspectionApi', PropertyInspectionApi)
    .service('PhoneApi', PhoneApi)
    .service('PromoterSurveyApi', PromoterSurveyApi)
    .service('DiscussionMessagesApi', DiscussionMessagesApi)
    .service('ApplicationsApi', ApplicationsApi)
    .service('AwatChecklistApi', AwatChecklistApi)
    .service('AwatSettingsApi', AwatSettingsApi)
    .service('RentalHistoryVerificationSettingsApi', RentalHistoryVerificationSettingsApi)
    .service('RentalHistoryVerificationRequestsApi', RentalHistoryVerificationRequestsApi)
    .service('NotesApi', NotesApi)
    .service('PropertyGroupsApi', PropertyGroupsApi)
    .service('AccountingBooksApi', AccountingBooksApi)
    .service('BackgroundChecksApi', BackgroundChecksApi)
    .service('BasicApplicantScreeningApi', BasicApplicantScreeningApi)
    .service('ReportsApi', ReportsApi)
    .service('AssociationOwnersApi', AssociationOwnersApi)
    .service('InsightsApi', InsightsApi)
    .service('AssociationTenantsApi', AssociationTenantsApi)
    .service('AccountingStartDateApi', AccountingStartDateApi)
    .service('NewAccountSetupApi', NewAccountSetupApi)
    .service('RentRollApi', RentRollApi)
    .service('EpaySignupApi', EpaySignupApi)
    .service('EpayBillingApi', EpayBillingApi)
    .service('EpaySettingsApi', EpaySettingsApi)
    .service('ChatApi', ChatApi)
    .service('InspectionsApi', InspectionsApi)
    .service('AddOnServicesSettingsApi', AddOnServicesSettingsApi)
    .service('PrioritySupportApi', PrioritySupportApi)
    .service('ESignAuthenticationApi', ESignAuthenticationApi)
    .service('StatesApi', StatesApi)
    .service('ESignBillingApi', ESignBillingApi)
    .service('ESignMembershipService', ESignMembershipService)
    .service('LeaseTemplatesApi', LeaseTemplatesApi)
    .service('TestEpayProvisioning', TestEpayProvisioning)
    .service('Misc1099Api', Misc1099Api)
    .service('UserEftAccountApi', UserEftAccountApi)
    .service('ChecksApi', ChecksApi)
    .service('CheckEftsApi', CheckEftsApi)
    .service('OwnerPortalApi', OwnerPortalApi)
    .service('PartnerPortalApi', PartnerPortalApi)
    .service('ApprovalsApi', ApprovalsApi)

    /*
        This is being used by aspx through run-walkme.js:
        run-walkme.js is copied by our build process (Manager/client/grunt/webpack.js)
        and made available as "js/auto/03-Plugins/angular-walkme"
     */
    .value('TrialWalkthroughApi', TrialWalkthroughApi)

    .service('CommunicationsApi', CommunicationsApi)
    .service('DraftEmailApi', DraftEmailApi)
    .service('ScheduledEmailApi', ScheduledEmailApi)
    .service('SiteMessagesApi', SiteMessagesApi)
    .service('ViolationsApi', ViolationsApi)
    .service('ProductUpdatesApi', ProductUpdatesApi)
    .service('RetailCashApi', RetailCashApi)
    .service('AutomatedEmailTemplatesApi', AutomatedEmailTemplatesApi)
    .service('MailingsApi', MailingsApi)
    .service('ShowingsCoordinatorApi', ShowingsCoordinatorApi)
    .service('UserProfilePhotoApi', UserProfilePhotoApi)
    .service('OutstandingBalancesApi', OutstandingBalancesApi)
    .service('EngagementApi', EngagementApi)
    .service('ApplicationBrandingApi', ApplicationBrandingApi)
    .service('BusinessProcessApi', BusinessProcessApi)
    .service('ImportsApi', ImportsApi)
    .service('ApplianceApi', ApplianceApi)
    .service('PropertyImagesApi', PropertyImagesApi)
    .service('SavingsRecommendationApi', SavingsRecommendationApi)
    .service('ApprovalLimitsApi', ApprovalLimitsApi)
    .service('RecurringChargesApi', RecurringChargesApi)
    .service('BoardMembersApi', BoardMembersApi)
    .service('TermsOfUseApi', TermsOfUseApi)
    .service('JournalApi', JournalApiService)
    .service('UserAgreementsApi', UserAgreementsApi)
    .service('CustomerBetaApi', CustomerBetaApi)
    .service('ResourceStringsApi', ResourceStringsApi)
    .service('OwnerDrawApi', OwnerDrawApi)
    .service('WebSocketsApi', WebSocketsApi)
    .service('CountryApi', CountryApi)
    .service('SetupTwoFactorAuthenticationApi', SetupTwoFactorAuthenticationApi)
    .service('TwoFactorAuthenticationApi', TwoFactorAuthenticationApi)
    .service('MarketingPreferencesApi', MarketingPreferencesApi)
    .service('ApprovalRequestsApi', ApprovalRequestsApi)
    .service('OutgoingEftRequestsApi', OutgoingEftRequestsApi)
    .service('OwnerContributionsApi', OwnerContributionsApi)
    .service('DepositsApi', DepositsApi)
    .service('UserSessionApi', UserSessionApi)
    .service('PrepaymentsApi', PrepaymentsApi)
    .service('ExternalApiManagementApi', ExternalApiManagementApi)

    .service('LoggingApi', LoggingApi)
    .service('ManagementIncomeApi', ManagementIncomeApi)
    .service('MailgunApi', MailgunApi)
    .service('SettingsApi', SettingsApi)
    .service('LeasesApi', LeasesApi)
    .service('BankAccountOpeningBalancesService', BankAccountOpeningBalancesApi)
    .service('TenantsApi', TenantsApi)
    .service('VendorsApi', VendorsApi)
    .service('AssociationUsersApi', AssociationUsersApi)
    .service('RentalOwnersApi', RentalOwnersApi)
    .service('ListingsApi', ListingsApi)
    .service('PropertiesApi', PropertiesApi)
    .service('RentApi', RentApi)
    .service('AssociationsApi', AssociationsApi)
    .service('MailingTemplateApi', MailingTemplateApi)
    .service('UsersApi', UsersApi)
    .service('AnnouncementApi', AnnouncementApi)
    .service('ContactsApi', ContactsApi)
    .service('RecurringTasksApi', RecurringTasksApi)
    .service('RecurringTransactionsApi', RecurringTransactionsApi)
    .service('BudgetsApi', BudgetsApi)
    .service('TasksApi', TasksApi)
    .service('ProjectsApi', ProjectsApi)
    .service('EventHistoryApi', EventHistoryApi)
    .service('ResidentsApi', ResidentsApi)
    .service('UserRolesApi', UserRolesApi)
    .service('CommonAllocationsApi', CommonAllocationsApi)
    .service('BankFeedApi', BankFeedApi)
    .service('BankFeedRulesApi', BankFeedRulesApi)
    .service('ExportsApi', ExportsApi)
    .service('PaymentsApi', PaymentsApi)
    .service('BillsApi', BillsApi)
    .service('InvoicesApi', InvoicesApi)
    .service('OcrApi', OcrApi)
    .service('RenewalsApi', RenewalsApi)
    .service('FinancialsApi', FinancialsApi)
    .service('MerchantLimitsApi', MerchantLimitsApi)
    .service('BankingApi', BankingApi)
    .service('BillingApi', BillingApi)
    .service('ViolationMailingsApi', ViolationMailingsApi)
    .service('ViolationEmailsApi', ViolationEmailsApi)
    .service('GeneralLedgerApi', GeneralLedgerApi)
    .service('ApmApi', ApmApi)
    .service('BillMarkupsApi', BillMarkupsApi)
    .service('PropertyContactsApi', PropertyContactsApi)
    .service('ApplicantsApi', ApplicantsApi)
    .service('LeaseStagesApi', LeaseStagesApi)
    .service('AccessKeysApi', AccessKeysApi)
    .service('GroupEmailApi', GroupEmailApi)
    .service('UnitDetailsApi', UnitDetailsApi)
    .service('ResidentInvoicesApi', ResidentInvoicesApi)
    .service('FeePolicySettingsApi', FeePolicySettingsApi)
    .service('ApplicationGroupsApi', ApplicationGroupsApi)
    .service('ActivityFeedApi', ActivityFeedApi)
    .service('OpenApiPartnersApi', OpenApiPartnersApi)
    .service('MarketplaceApi', MarketplaceApi)
    .service('UnreadActivitiesApi', UnreadActivitiesApi)
    .service('BankVerificationApi', BankVerificationApi)
    .service('WebhooksEventHistoryApi', WebhooksEventHistoryApi)
    .service('PremiumApplicantScreeningApi', PremiumApplicantScreeningApi)
    .service('AssociationCommitteesApi', AssociationCommitteesApi)
    .service('AssociationArchitecturalRequestsApi', AssociationArchitecturalRequestsApi)
    .service('ArchitecturalRequestsApi', ArchitecturalRequestsApi)
    .service('ArchitecturalRequestApprovalsApi', ArchitecturalRequestApprovalsApi)
    .service('UnauthenticatedAccountSettingsApi', UnauthenticatedAccountSettingsApi)
    .service('MasterInsuranceApi', MasterInsuranceApi)
    .service('SetupIntentsApi', SetupIntentsApi)
    .service('LockboxProcessingApi', LockboxProcessingApi)
    .service('ApplicationFinancialsApi', ApplicationFinancialsApi)
    .service('ApplicationPaymentsApi', ApplicationPaymentsApi)
    .service('ApplicationChargesApi', ApplicationChargesApi)
    .service('ApplicationReversedPaymentsApi', ApplicationReversedPaymentsApi)
    .service('PropertySettingsApi', PropertySettingsApi)
    .service('ApplicationRefundsApi', ApplicationRefundsApi)
    .service('ApplicationInvoicesApi', ApplicationInvoicesApi)
    .service('TotalPercentageDistributionApi', TotalPercentageDistributionApi)
    .service('MerchantApplicationDocumentApi', MerchantApplicationDocumentApi)
    .service('KnownOpenApiPartnersApi', KnownOpenApiPartnersApi)
    .service('ReturnedPaymentAutomationFeeApi', ReturnedPaymentAutomationFeeApi)
    .service('BinRangesApi', BinRangesApi)
    .service('ReturnedPaymentAutomationBankFeesApi', ReturnedPaymentAutomationBankFeesApi)
    .service('ReversedEFTRefundsApi', ReversedEFTRefundsApi)
    .service('CreditCardAccountsApi', CreditCardAccountsApi)
    .service('CreditCardPurchasesApi', CreditCardPurchasesApi)
    .service('CreditCardBalancePaymentsApi', CreditCardBalancePaymentsApi)
    .service('ProjectsApi', ProjectsApi)
    .service('VirtualAssistantApi', VirtualAssistantApi)
    .service('RentalProspectSharedApi', RentalProspectSharedApi)
    .service('ProjectTemplatesApi', ProjectTemplatesApi)
    .service('EmailSettingsApi', EmailSettingsApi)
    .service('ProjectTemplateTasksApi', ProjectTemplateTasksApi)
    .service('ApplicationFeesApi', ApplicationFeesApi)
    .service('WorkSessionsApi', WorkSessionsApi)
    .service('SecurityDepositPartnerApi', SecurityDepositPartnerApi);
